import PropertyRightDrawerContainer from "../../../components/property/other/PropertyRightDrawer";

const PropertyRightDrawer = () => {
  return <PropertyRightDrawerContainer />;
};

export default PropertyRightDrawer;
